
import RequestPromises from "@/mixins/requestPromises";
import { IProvider } from "@/models/providers";
import { DataModules } from "@/store/modules/data";
import { CreateElement } from "vue";
import { Component, Mixins, Prop, Provide } from "vue-property-decorator";
import {
  IUpmindUsageProviderData,
  IUpmindUsageProviderMethods
} from "@/models/providers/upmind";
import { IOrg } from "@/models/organisation";

@Component
export default class UpmindUsageProvider extends Mixins(RequestPromises)
  implements IProvider {
  // Props

  @Prop({ default: null })
  public clientId!: boolean;

  @Prop({ default: false })
  public handleLoading!: boolean;

  @Prop({ default: () => ({}) })
  public loaderAttrs!: Record<string, any>;

  @Prop({ default: true })
  public handleRequestError!: boolean;

  @Prop({ required: true })
  public packageLimits!: IOrg["upmind_package_limits"];

  // Data

  public isLoading = true;
  public isReloading = false;
  public hasRequestError = false;

  public usage = {} as {
    brands: number;
    clients: number;
    invoices_per_current_bc: number;
    payment_gateways: number;
    provisioning_configurations: number;
    users: number;
  };

  // Life-cycle methods

  public created() {
    this.loadData();
  }

  @Provide("upmindUsageProviderMethods")
  public get providerMethods(): IUpmindUsageProviderMethods {
    return {
      reloadData: this.reloadData
    };
  }

  @Provide("upmindUsageProvider")
  public providerData(): IUpmindUsageProviderData {
    return {
      packageLimits: this.packageLimits,
      isLoading: this.isLoading,
      isReloading: this.isReloading,
      hasRequestError: this.hasRequestError,
      brands: this.usage?.brands || 0,
      clients: this.usage?.clients || 0,
      invoices_per_current_bc: this.usage?.invoices_per_current_bc || 0,
      payment_gateways: this.usage?.payment_gateways || 0,
      provisioning_configurations: this.usage?.provisioning_configurations || 0,
      users: this.usage?.users || 0
    };
  }

  // Computed

  // Methods

  public async loadData() {
    try {
      this.usage = await this.getUsage();
      this.hasRequestError = false;
    } catch (error) {
      this.hasRequestError = true;
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    return this.loadData();
  }

  public getUsage() {
    return this.$store.dispatch(`data/${DataModules.UPMIND}/getUpmindUsage`, {
      clientId: this.clientId
    });
  }

  //  Render

  public render(h: CreateElement) {
    // Handle loading
    if (this.handleLoading && this.isLoading)
      return h("is-loading", { props: { if: true }, attrs: this.loaderAttrs });
    // Handle request error
    if (this.handleRequestError && this.hasRequestError)
      return h("request-error", {
        props: { isLoading: this.isReloading },
        on: { click: () => this.reloadData() }
      });
    return (
      this.$scopedSlots?.default &&
      this.$scopedSlots.default({
        $usageData: this.providerData(),
        $usageMethods: this.providerMethods
      })
    );
  }
}
